<template>
  <div class="notify-popup-employer-wrapper" v-if="notifyPopupEmployer">
    <div class="notify-popup-employer-window">
      <div class="notify-popup-employer-close" @click="close()">
        <v-icon>close</v-icon>
      </div>
      <div class="notify-popup-employer-message" v-html="notifyPopupMessage"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'

export default {
  name: 'NotifyPopupEmployer',
  data: () => {
    return {
      notifyPopupEmployer: false,
      notifyPopupMessage: '',
    }
  },
  methods: {
    async getMessage() {
      await axios
        .get(`${Vue.config.server}/${Vue.config.modules.crm.api.notifyPopupEmployer.all}`)
        // eslint-disable-next-line promise/always-return
        .then(response => {
          // eslint-disable-next-line promise/always-return
          if (response.data.data) {
            this.processData(response.data.data)
          }
        })
    },
    close() {
      this.notifyPopupEmployer = false
    },
    processData(data) {
      for (const item of data) {
        this.setTimeouts(item)
      }
    },
    setTimeouts(item) {
      for (const hour of item.hours) {
        this.setOneTimeout(hour, item.message)
      }
    },
    setOneTimeout(hour, message) {
      let current = new Date()
      // for testing:
      // let currentH = new Date(current.getFullYear(), current.getMonth(), current.getDate(), 17)

      let targetDate = new Date(current.getFullYear(), current.getMonth(), current.getDate(), hour)

      let currentTime = current.valueOf()
      // let currentTime = currentH.valueOf()
      let targetTime = targetDate.valueOf()

      let diff = targetTime - currentTime

      if (diff >= 0) {
        setTimeout(() => {
          this.notifyPopupEmployer = true
          this.notifyPopupMessage = message
        }, diff)
      }
    },
  },
  mounted() {
    this.getMessage()
  },
}
</script>

<style scoped>
.notify-popup-employer-wrapper {
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  z-index: 10000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notify-popup-employer-window {
  background-color: #fff;
  width: 500px;
  height: 300px;
  padding: 30px;
  display: flex;
  align-items: center;
  position: relative;
  box-shadow: 10px 10px 30px gray;
}
@media (max-width: 500px) {
  .notify-popup-employer-window {
    width: 100%;
    height: auto;
  }
}
.notify-popup-employer-message {
  text-align: center;
  font-size: 20px;
}
.notify-popup-employer-close {
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
}
.notify-popup-employer-close .v-icon {
  font-size: 32px;
}
</style>
